import React, {useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {LanguageSelector} from "./LanguageSelector";
import {RootState} from "../../reducers/RootReducer";
import {useSelector} from "react-redux";
import {useUser} from "../../hooks/CommonHooks";

export function Footer() {
    const t = useIntl();
    const language = useSelector<RootState, string>(state => state.user.language);
    const country = useSelector<RootState, string>(state => state.user.country);
    const user = useUser();
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    
    return (
        <nav className="navbar navbar-expand-lg navbar-light fixed-bottom" id="appFooter">
            <div className="collapse navbar-collapse container text-secondary">
                <ul className="navbar-nav pl-md-5">
                    <li className="nav-item">
                        <span><FormattedMessage id={"site.copyright"} values={{ year: currentYear }} /></span>
                    </li>
                </ul>
                <ul className="navbar-nav pr-5">
                    <li className="nav-item active">
                        <span>Version 1.4.27</span>
                    </li>
                    <li className="nav-item active">
                        <span><a target={"_blank"} href={t.formatMessage({id: "site.privacy_url", defaultMessage: ""}, {language, country})}><FormattedMessage id={"site.privacy"}/></a></span>
                    </li>
                    <li className="nav-item">
                        <span><a target={"_blank"} href={t.formatMessage({id: "site.terms_conditions_url", defaultMessage: ""}, {language, country})}><FormattedMessage id={"site.terms_conditions"}/></a></span>
                    </li>
                    <li className="nav-item">
                        <span><a target={"_blank"} href={t.formatMessage({id: "site.contact_us_url", defaultMessage: ""}, {language, country})}><FormattedMessage id={"site.contact_us"}/></a></span>
                    </li>
                    {user?.third_party_id === "" && <li className="nav-item">
                        <LanguageSelector/>
                    </li>}
                </ul>
            </div>
        </nav>
    );
}

